import styled from '@emotion/styled';

export const StyledInlineErrorState = styled('div')(({ theme }) => ({
  backgroundColor:
    theme.colorScheme === 'dark' ? theme.colors.red[9] : theme.colors.red[0],
  border: `1px solid ${
    theme.colorScheme === 'dark' ? theme.colors.red[8] : theme.colors.red[2]
  }`,
  borderRadius: 0,
  padding: '12px 16px',
}));

export const StyledInlineErrorMessage = styled('div')(({ theme }) => ({
  color: theme.colors.red[6],
  fontSize: '0.875rem',
  fontWeight: 500,
}));
